module.exports=[{name:"cat",label:"Català"},{name:"en",label:"English"}];